'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _pubsubJs = require('pubsub-js');

var _pubsubJs2 = _interopRequireDefault(_pubsubJs);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

var _product = require('state/product');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleOpenQuickshopClick = function handleOpenQuickshopClick(_ref) {
  var self = _ref.currentTarget;

  var productContainer = _Dom2.default.getParentContainer(self);
  var containerData = (0, _product.getProductContainerData)(productContainer);
  var topic = _Constants2.default.showModal;
  var modalData = { id: productContainer.dataset.containerId, containerData: containerData };
  var data = { name: 'quickshop', data: Object.assign({}, modalData) };

  _pubsubJs2.default.publish(topic, data);

  return false;
};

var bindActions = exports.bindActions = function bindActions() {
  $(_Dom2.default.openQuickshop).on('click', handleOpenQuickshopClick);
};